import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticatedGuard } from '../../../guards/authenticated.guard';
import { FilterPageModule } from './filter/filter.module';
import { HelpPageModule } from './help/help.module';
import { ViewPageComponent } from './view.component';

const routes: Routes = [
  {
    canActivate: [AuthenticatedGuard],
    component: ViewPageComponent,
    path: ''
  },
  {
    canActivate: [AuthenticatedGuard],
    loadChildren: () => FilterPageModule,
    path: 'filter'
  },
  {
    canActivate: [AuthenticatedGuard],
    loadChildren: () => HelpPageModule,
    path: 'help'
  }
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forChild(routes)]
})
export class ViewPageRoutingModule {}
